import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ErrorsService, CARREGAR, SALVAR, ATUALIZAR, ENVIAR } from '../errors/errors.service';
import { URL_API } from 'src/app/tools/URL';
import { retry, catchError } from 'rxjs/operators';
import { SugestaoVO } from 'src/app/entity/SugestaoVO';
import { AuthService } from '../autenticacao/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SugestaoService {
  sugestao = this.builder.group(this.preencherVo());

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) { }

  carregarDados() {
    return this.rest.get(`${URL_API.PATH_SUGESTAO}/carregar`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarDadosService() {

    this.carregarDados().subscribe(retorno => {
      this.sugestao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      this.sugestao.controls.assuntos.setValue(retorno.assuntos);
    });

  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_SUGESTAO + '/' + id}`);

  }

  gravarManifestoOperador(manifestante, arquivos = [], isEnviar) {

    this.sugestao.controls.nome.setValue(manifestante.nome);
    this.sugestao.controls.email.setValue(manifestante.email);
    this.sugestao.controls.username.setValue(this.authService.usuarioLogado.username);

    this.sugestao.controls.files.setValue([]);
    arquivos.forEach((value, key) => {
      this.sugestao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    return isEnviar ? this.enviar(this.sugestao.value) : this.salvar(this.sugestao.value);

  }

  salvar(obj) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  public enviar(obj: SugestaoVO) {
    return this.rest.post(`${URL_API.PATH_SUGESTAO}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  private gravar(obj: SugestaoVO) {
    return this.rest.post(`${URL_API.PATH_SUGESTAO}/salvar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  private atualizar(obj) {
    return this.rest.put(`${URL_API.PATH_SUGESTAO}/salvar/${obj.id}`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ATUALIZAR))
    );
  }

  preencherVo() {
    return {
      id: null,
      files: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      nome: new FormControl({ value: null }, [Validators.required]),
      email: new FormControl({ value: null }, [Validators.required]),
      assunto: new FormControl(null, [Validators.required]),
      descricaoSugestao: new FormControl(null, [Validators.required]),
      listaClassificacao: new FormControl([], [Validators.required]),
      listaClassificacaoCompleta: [],
      assuntos: [],

      demandaRecebida: new FormControl(null)

    } as SugestaoVO;
  }
}
